import React, { useState, useEffect, useContext } from "react";
import HomeSlider from "./slider/HomeSlider";
import Catsliders from "../../components/catslider";
import Banners from "../../components/banners";
import Products from "../../components/Product";
import ProductSkeleton from "../../components/Product/ProductSkeleton";
import Slider from "react-slick";
import cartanner from "../../assets/images/cartanner.jpg";
import TopProducts from "../Home/Topproducts/index";
import { fetchDataFromApi } from "../../utils/api";
import "./style.css";
import { MyContext } from "../../App";

const Home = () => {
  const myContext = useContext(MyContext);
  const [popularCategories, setPopularCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [FilterData, setFilterData] = useState([]);
  const [dailyBestProducts, setDailyBestProducts] = useState([]);
  const [loadingCategories, setLoadingCategories] = useState(true);
  const [loadingDailyBest, setLoadingDailyBest] = useState(false);
  const [categoryError, setCategoryError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [homeSlides, setHomeSlides] = useState([]);

  useEffect(() => {
    const fetchInitialProducts = async () => {
      setIsLoading(true);
      const location = localStorage.getItem("location") || "";

      try {
        const res = await fetchDataFromApi(
          `/api/products?location=${location}`
        );

        setFilterData(res?.products || []);

        const bannerRes = await fetchDataFromApi("/api/homeBanner");
        setHomeSlides(bannerRes || []);
      } catch (error) {
        console.error("Error fetching initial products:", error);
        setFilterData([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchInitialProducts();
  }, []);

  useEffect(() => {
    if (selectedCategory === null || selectedCategory === undefined) {
      return;
    }

    const fetchCategoryProducts = async () => {
      setIsLoading(true);
      const location = localStorage.getItem("location") || "";

      try {
        let url = "";
        if (selectedCategory === "all") {
          url = `/api/products?location=${location}`;
        } else {
          url = `/api/products?catId=${selectedCategory}&location=${location}`;
        }

        const res = await fetchDataFromApi(url);

        setFilterData(res?.products || []);
      } catch (error) {
        console.error("Error fetching category products:", error);
        setFilterData([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCategoryProducts();
  }, [selectedCategory]);

  useEffect(() => {
    const fetchDailyBestProducts = async () => {
      try {
        setLoadingDailyBest(true);
        const location = localStorage.getItem("location") || "";

        const res = await fetchDataFromApi(
          `/api/products?location=${location}&limit=10`
        );

        if (res?.products && Array.isArray(res.products)) {
          const reversedProducts = [...res.products].reverse();
          setDailyBestProducts(reversedProducts.slice(0, 10));
        } else {
          setDailyBestProducts([]);
        }
      } catch (error) {
        console.error("Error fetching daily best products:", error);
        setDailyBestProducts([]);
      } finally {
        setLoadingDailyBest(false);
      }
    };

    fetchDailyBestProducts();
  }, []);

  useEffect(() => {
    if (
      FilterData.length > 0 &&
      dailyBestProducts.length === 0 &&
      !loadingDailyBest
    ) {
      const reversedFilterData = [...FilterData].reverse().slice(0, 10);
      setDailyBestProducts(reversedFilterData);
    }
  }, [FilterData, dailyBestProducts.length, loadingDailyBest]);

  useEffect(() => {
    const fetchPopularCategories = async () => {
      try {
        setLoadingCategories(true);
        const res = await fetchDataFromApi("/api/category");

        if (res?.categoryList && Array.isArray(res.categoryList)) {
          const allCategories = res.categoryList.map((cat) => ({
            ...cat,
            parentName: cat.name,
            parentId: cat._id,
          }));

          setPopularCategories(allCategories);
        } else {
          setPopularCategories([]);
        }
      } catch (err) {
        console.error("API Error fetching popular categories:", err);
        setCategoryError("Failed to load popular categories.");
      } finally {
        setLoadingCategories(false);
      }
    };
    fetchPopularCategories();
  }, []);

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    fade: false,
    arrows: true,
    autoplay: 3000,
    centerMode: true,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 3 } },
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 576, settings: { slidesToShow: 1 } },
    ],
  };

  const getDailyBestTag = (index) => {
    const tags = ["hot", "sale", "best", "new", "trending"];
    return tags[index % tags.length];
  };

  const handleCategoryClick = (catId) => {

    setSelectedCategory(catId);
  };

  return (
    <>
      {isLoading && homeSlides.length === 0 ? (
        <div className="container-fluid mt-3">
          <div className="skeleton" style={{ width: '100%', height: '450px', borderRadius: '30px' }} />
        </div>
      ) : (
        homeSlides?.length !== 0 && <HomeSlider data={homeSlides} />
      )}

      <Catsliders />

      <section className="homeProducts">
        <div className="container-fluid">
          <div className="d-flex align-items-center justify-content-between mb-3">
            <h2 className="hd mb-0 mt-0">Popular Products</h2>
            <div className="category-slider" style={{ width: "50%" }}>
              {loadingCategories ? (
                <div className="d-flex justify-content-end gap-2">
                  {[1, 2, 3, 4].map(i => (
                    <div key={i} className="skeleton cat-tab-skeleton" style={{ width: '80px', height: '30px', borderRadius: '15px' }} />
                  ))}
                </div>
              ) : (
                <Slider
                  dots={false}
                  infinite={false}
                  speed={500}
                  slidesToShow={5}
                  slidesToScroll={2}
                  arrows={true}
                  responsive={[
                    { breakpoint: 1200, settings: { slidesToShow: 4 } },
                    { breakpoint: 992, settings: { slidesToShow: 3 } },
                    { breakpoint: 768, settings: { slidesToShow: 2 } },
                    { breakpoint: 576, settings: { slidesToShow: 1 } },
                  ]}
                >
                  <div
                    className={`category-tab ${selectedCategory === "all" ? "active" : ""
                      }`}
                    onClick={() => handleCategoryClick("all")}
                    style={{ cursor: "pointer" }}
                  >
                    All
                  </div>

                  {popularCategories.map((cat) => (
                    <div
                      key={cat._id}
                      className={`category-tab ${selectedCategory === cat._id ? "active" : ""
                        }`}
                      onClick={() => handleCategoryClick(cat._id)}
                      style={{ cursor: "pointer" }}
                    >
                      {cat.name}
                    </div>
                  ))}
                </Slider>
              )}
            </div>
          </div>

          <div className="productRow">
            {isLoading && FilterData.length === 0 ? (
              <>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
                  <div key={i} className="item">
                    <ProductSkeleton />
                  </div>
                ))}
              </>
            ) : FilterData && FilterData.length > 0 ? (
              FilterData.map((item, index) => (
                <div className="item fade-in" key={item._id || item.id || index}>
                  <Products item={item} />
                </div>
              ))
            ) : (
              <div className="text-center p-4 w-100">
                <p className="text-muted">
                  No products found for the selected category.
                </p>
                <button
                  className="btn btn-success"
                  onClick={() => handleCategoryClick("all")}
                >
                  View All Products
                </button>
              </div>
            )}
          </div>
        </div>
      </section>

      <Banners />

      <section className="homeProducts homeProductsRow2 pt-0">
        <div className="container-fluid">
          <div className="d-flex align-items-center">
            <h2 className="hd mb-0 mt-0">Daily Best Sells</h2>
          </div>
          <br />
          <div className="row">
            <div className="col-md-3 pr-5">
              <img src={cartanner} className="w-100 cart-my" alt="Banner" />
            </div>
            <div className="col-md-9">
              {loadingDailyBest ? (
                <div className="productRow" style={{ margin: '0' }}>
                  {[1, 2, 3].map((i) => (
                    <div key={i} className="item" style={{ flex: '0 0 33.33%', padding: '0 10px' }}>
                      <ProductSkeleton />
                    </div>
                  ))}
                </div>
              ) : (
                <Slider {...settings} className="prodSlider">
                  {dailyBestProducts.length > 0 ? (
                    dailyBestProducts.map((product, index) => (
                      <div
                        className="item"
                        key={product._id || product.id || index}
                      >
                        <Products item={product} tag={getDailyBestTag(index)} />
                      </div>
                    ))
                  ) : (
                    <div className="item">
                      <div className="text-center p-4">
                        <p className="text-muted">
                          No daily best products available
                        </p>
                      </div>
                    </div>
                  )}
                </Slider>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
